import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonService } from 'src/app/_services/common.service';
@Component({
  selector: 'app-products-grc',
  templateUrl: './products-grc.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./products-grc.component.scss'],
})
export class ProductsGrcComponent implements OnInit {
  banner = {
    imageText:"GRC Consulting",
    imageUrl:"/assets/images/Frame48096932.jpg",
    buttonText:"Learn more",
    routerButton: '/services/Consultations'
  }
  currentLanguage = this.commonService.currentLanguage;
  subImgUrl= '../../../../assets/svg/autonio.svg'
  subTitle= 'Our certified experts can help you with the assessment and implementation of your GRC program';
  header: string = 'GRC Automation';
  description: string ='Easier Compliance Faster Audits and Better Risk Visibility';
  joinChat: boolean = false;
  imagePath = '../../../../assets/svg/GRC hero En.svg';
  hasBtn: boolean = true;
  routerHeroButton = '/contact-us';
  buttonText = 'Request a demo';
  buttoffnText = 'Book a demo';
  backgroundColor = '#E1E7EE'
  isProductsPage: boolean = true;
  isProductLogo: boolean = true;
  logoPath ='../assets/svg/Easycompliance®.svg'
  sectionInputTwoCards: any = [
    {
      description:
        'Pre-built libraries of awareness content including courses, posters, and phishing templates. ',
      imagePath: '../../../../assets/images/image4.png',
    },
    {
      description:
        'New content is added continuously to keep your program up to date with latest threats trends. ',
      imagePath: '../../../../assets/images/image3.png',
    },
    {
      description: 'Launch campaigns with professional content in seconds. ',
      imagePath: '../../../../assets/images/image2.png',
    },
    {
      description:
        'New content is added continuously to keep your program up to date with latest threats trends. ',
      imagePath: '../../../../assets/images/image1.png',
    },
  ];

  sectionCards: { imagePath: string; description: string; title: string }[] = [
    {
      title: 'Clone Framework',
      description:
        'Clone a framework from a multitude of options already available on our database  ',
      imagePath: '../../../../assets/images/clone.svg',
    },
    {
      title: 'Map Evidence',
      description:
        'Define your compliance level based on the date from the system ',
      imagePath: '../../../../assets/images/map.svg',
    },
    {
      title: 'Assess Compliance',
      description:
        'Define your compliance level based on the date from the system',
      imagePath: '../../../../assets/images/assess.svg',
    },
  ];

  sectionNine: { imagePath: string; title: string }[] = [
    {
      title: 'Cybersecurity',
      imagePath: '../../../../assets/images/section-nine1.svg',
    },
    {
      title: 'Data',
      imagePath: '../../../../assets/images/section-nine2.svg',
    },
    {
      title: 'Business Continuity',
      imagePath: '../../../../assets/images/section-nine3.svg',
    },
    {
      title: 'Quality',
      imagePath: '../../../../assets/images/section-nine4.svg',
    },
  ];



  constructor(private commonService: CommonService) {}

  ngOnInit(): void {
    if(this.currentLanguage == 'en'){
      this.imagePath = '../../../../assets/images/GRC hero En.png';
    }else{
      this.imagePath = '../../../../assets/images/GRC hero Ar.png';
    }
  }
}
